var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Icon',{attrs:{"src":"user"},on:{"click":function($event){return _vm.say('clicked')}}}),_c('Icon',{attrs:{"src":"password"}}),_c('Icon',{attrs:{"src":"eye-open"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }